<template>
  <div class="main">
    <div class="main-top">
      <div class="main-top-fl">
        <div class="w11">
          <a href="/">
            <img src="../../../assets/images/home/zf1.png" alt=""
          /></a>

          <div class="main-top-p">
            <h3>{{ $t('login.data1') }}</h3>
            <!--            <p>极联F2S2B汽配供应链平台</p>-->
          </div>
        </div>

        <!--        <h4>客服电话：<i>187-4993-8350</i></h4>-->
      </div>
      <!-- <div class="main-top-fr"> -->
      <!-- <span class="banckHome" @click="$router.push({ path: '/' })"
          >返回首页</span
        > -->
      <!-- <p>客服热线：186-2139-8863</p> -->
      <!-- </div> -->
    </div>

    <!-- 轮播图 -->
    <div class="main-bg">
      <div class="main-body">
        <img
          src="@/assets/images/home/login-bg1.png"
          alt=""
          style="width: 560px; height: 320px; margin-left: 147px"
        />
        <!-- 登录 -->
        <div class="main-login" @keydown.enter="handleSubmit('formInline')">
          <div class="div-p">
            <p class="p-1">{{ $t('login.data6') }}</p>
            <Dropdown translate transfer-class-name="DropdownDom">
              <img
                class="languageIcon"
                src="../../../assets/Language.svg"
                alt=""
              />
              <template #list>
                <DropdownMenu @on-click="setLang('ch')">
                  <p
                    id="tags-p"
                    :class="langName == '简体中文' ? 'isDisabled' : ''"
                    @click="setLang('ch', langName == '简体中文')"
                  >
                    简体中文
                  </p>
                  <p
                    id="tags-p"
                    :class="langName == 'English' ? 'isDisabled' : ''"
                    @click="setLang('en', langName == 'English')"
                  >
                    English
                  </p>
                </DropdownMenu>
              </template>
            </Dropdown>
            <!-- <p class="pp">/</p> -->
            <!-- <p class="p-2">/&nbsp;&nbsp;极联F2S2B汽配供应链平台</p> -->
          </div>
          <p class="w122">{{ $t('login.data5') }}</p>
          <div class="main-form">
            <Form ref="formInline" :model="formInline" :rules="ruleInline">
              <FormItem prop="username" class="main-form-username">
                <Input
                  type="text"
                  v-model="formInline.username"
                  :placeholder="$t('login.data4')"
                  id="biaodan"
                >
                  <span class="iconfont icon-ziyuanxhdpi" slot="prefix"></span>
                </Input>
              </FormItem>
              <FormItem prop="password">
                <Input
                  style="border: none"
                  :type="passwordType ? 'password' : 'text'"
                  v-model="formInline.password"
                  :placeholder="$t('login.data3')"
                >
                  <span
                    class="iconfont icon-kaisuohuansuo"
                    slot="prefix"
                  ></span>
                  <Icon
                    class="eye"
                    color="#BBBBBB"
                    :type="passwordType ? 'md-eye-off' : 'md-eye'"
                    slot="suffix"
                    @click="passwordType = !passwordType"
                  />"
                </Input>
              </FormItem>
              <!-- <FormItem> -->
              <!-- <Button
                style="background-color: #c9c9c9"
                v-show="isEnter"
                class="login-no"
                long
                >登录</Button
              > -->
              <Button
                class="login-no"
                type="primary"
                long
                @click="handleSubmit('formInline')"
                :loading="loading"
                >{{ $t('login.data2') }}</Button
              >
              <!-- </FormItem> -->
            </Form>
          </div>
          <!--          <div class="main-spans">-->
          <!--            <router-link :to="{ path: '/forgetpwd' }" rel="opener">-->
          <!--              <i class="i">忘记密码</i></router-link-->
          <!--            >-->
          <!--            <i class="i-2">/</i>-->
          <!--            <router-link :to="{ path: '/register' }" rel="opener">-->
          <!--              <i class="i">欢迎注册</i></router-link-->
          <!--            >-->
          <!--          </div>-->
        </div>
      </div>
      <!-- Swiper -->
      <!-- <div class="swiper-container"> -->
      <!-- <div class="swiper-wrapper"> -->
      <!-- 这里插入图片 轮播图1，2，3-->
      <!-- <div class="swiper-slide">
            <img src="../../../assets/images/home/login-bg1.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/images/home/login-bg2.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/images/home/login-bg3.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/images/home/login-bg4.jpg" alt="" />
          </div>
        </div> -->
      <!-- 分页器 -->
      <!-- <div class="swiper-pagination"></div>
      </div> -->
    </div>

    <Login-Footer></Login-Footer>
  </div>
</template>

<script>
import LoginFooter from './components/login-footer.vue'
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
// import { login } from '../api/user.js'
import { mapActions } from 'vuex'
// import { getAliOssKey } from '../uploadify/index'
export default {
  components: { LoginFooter },
  data() {
    return {
      langName: 'English',
      // isEnter: true,
      passwordType: true,
      loading: false,
      // searchURL: '',
      idddddd: '',
      formInline: {
        username: '',
        password: ''
      },
      ruleInline: {
        username: [
          {
            required: true,
            message: '请输入手机号/账号',
            trigger: 'blur'
          }
          // {
          //   pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
          //   message: '手机号码格式不正确',
          //   trigger: 'blur'
          // }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
          // {
          //   type: 'string',
          //   min: 6,
          //   message: '长度必须6位及以上',
          //   trigger: 'blur'
          // }
        ]
      }
    }
  },
  created() {
      localStorage.setItem('lang', 'English')
    // console.log(this.formInline, '123')
  },
  methods: {
    ...mapActions(['handleLogin']),
    // 登录
    // 失焦
    // verifyInput() {
    //   this.$refs.formInline.validate((valid) => {
    //     if (valid) {
    //       this.isEnter = false
    //     } else {
    //       this.isEnter = true
    //     }
    //   })
    // },
    // blurBtn(name) {
    //   this.$refs[name].validate((valid) => {
    //     if (valid) {
    //       this.isEnter = false
    //     } else {
    //       this.isEnter = true
    //       //
    //     }
    //   })
    // },
    setLang(lang, type) {
      if (type) {
        return
      }
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.langName = this.getLangName(this.$i18n.locale)
      // 刷新页面
      // window.location.reload()
    },
    getLangName(lang) {
      if (lang === 'ch') {
        return '简体中文'
      } else if (lang === 'en') {
        return 'English'
      }
    },
    async handleSubmit(name) {
      // console.log(this.formInline, '123')
      var searchURL = window.location.search
      if (searchURL) {
        searchURL = searchURL.substring(1, searchURL.length)
        var targetPageId = searchURL.split('&')[0].split('=')[1]
        if (targetPageId == '1') {
          this.idddddd = 1
        } else {
          this.idddddd = 0
        }
      } else {
        this.idddddd = 0
      }

      this.loading = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = false
          if (localStorage.getItem('deviceId')) {
            // localStorage.setItem('siderList', JSON.stringify(siderList))
            let data = {
              username: this.formInline.username.trim(),
              password: this.formInline.password.trim(),
              type: 1,
              deviceId: localStorage.getItem('deviceId'),
              autotest: this.idddddd
            }
            this.login(data)
          } else {
            localStorage.setItem('deviceId', this.guid())
            // localStorage.setItem('siderList', JSON.stringify(siderList))
            let data = {
              username: this.formInline.username.trim(),
              password: this.formInline.password.trim(),
              type: 1,
              deviceId: localStorage.getItem('deviceId'),
              autotest: this.idddddd
            }
            this.login(data)
          }
        } else {
          this.loading = false
        }
      })
    },
    // getautotest() {
    //   var searchURL = window.location.search
    //   // searchURL = searchURL.substring(1, searchURL.length)
    //   // var targetPageId = searchURL.split('&')[0].split('=')[1]
    //   if (searchURL) {
    //     console.log('我走了这一步')
    //     this.idddddd = 'dgegygrtth'
    //     // console.log(this.idddddd)
    //     // console.log(searchURL)
    //     // searchURL = searchURL.substring(1, searchURL.length)
    //     // console.log(searchURL)
    //     // var targetPageId = searchURL.split('&')[0].split('=')[1]
    //     // console.log(targetPageId)
    //     // if (targetPageId == '1') {
    //     // console.log(this.idddddd)
    //     // }
    //     // console.log(typeof targetPageId)
    //     // if (targetPageId == '1') {
    //     //   console.log(Number(this.idddddd))
    //     //   this.idddddd == Number(targetPageId)
    //     //   console.log(this.idddddd)
    //     // } else {
    //     //   console.log(Number(this.idddddd))
    //     //   this.idddddd == '牛逼'
    //     console.log(this.idddddd)
    //     // }
    //   } else {
    //     // console.log(Number(this.idddddd))
    //     this.idddddd = ''
    //     console.log(this.idddddd, '不存在谢谢')
    //   }
    // },

    login(data) {
      this.handleLogin(data).then((res) => {
        // console.log(res)
        if (res.tenantAudited == 0 || res.tenantAudited == 1) {
          this.$Message.warning(
            '您的申请正在审核中，客服会在5个工作日联系您，核实信息，请耐心等待'
          )
        } else if (res.tenantAudited == 2) {
          this.$router.push({
            name: 'register',
            query: {
              tenantAudited: res.tenantAudited,
              mobile: res.phone
            }
          })
        } else {
          // localStorage.setItem('username', data.username)
          // console.log(1111111111)

          // this.getUserInfo().then(res => {
          //   console.log(res)
          // })
          if (res.userdetails.leagueInfo.hasShareHolder == 0) {
            // console.log(22)
            if (sessionStorage.getItem('goPage') == 'shareholder') {
              sessionStorage.setItem('goPage', 'home')
            }
          }
          this.$router.push({
            // name: 'myweb_index',
            name: sessionStorage.getItem('goPage') || 'supportself',
            query: {
              tenantAudited: res.tenantAudited
            }
          })
          // console.log(sessionStorage.getItem('goPage'))
          // this.$router.push({
          //   // name: 'myweb_index',
          //   name: sessionStorage.getItem('goPage') || 'home',
          //   query: {
          //     tenantAudited: res.tenantAudited
          //   }
          // })
        }
      })
    },
    // 随机生成uuid方法
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        }
      )
    }
  },
  mounted() {
    // let dom = document.getElementById('biaodan')
    // console.log(dom)
    // console.log(this.formInline, '123')
    // window.onload = function () {
    // this.verifyInput()
    // 与此相同 window.addEventListener('load', (event) => {
    // alert(this)
  }
  // var mySwiper = new Swiper('.swiper-container', {
  //   direction: 'horizontal',
  //   // 自动切换
  //   autoplay: {
  //     delay: 1000
  //   },
  //   effect: 'fade',
  //   // 无限循环
  //   loop: true,
  //   // 切换的速度
  //   speed: 2000,
  //   // 分页器
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //     dynamicBullets: true
  //   }
  // })
  // }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .main-top {
    width: 1200px;
    height: 98px;
    // line-height: 160px;
    margin: 0 auto;
    // display: flex;
    .main-top-fl {
      display: flex;
      // padding-bottom: 9px;
      padding-top: 35px;
      justify-content: space-between;
      .w11 {
        display: flex;
        img {
          width: 178px;
          height: 50px;
          margin-right: 16px;
        }

        .main-top-p {
          // line-height: 0;
          height: 50px;
          text-align: center;
          p {
            color: #b7b7b7;

            letter-spacing: 1px;
            font-size: 14px;
            line-height: 21px;
          }
          h3 {
            line-height: 26px;
            letter-spacing: 4px;
            font-weight: normal;
            font-size: 16px;
            color: #444650;
            padding-bottom: 5px;
            border-bottom: 1px solid #e2e2e2;
          }
        }
      }
      h4 {
        padding-top: 30px;
        font-weight: normal;
        font-size: 16px;
        color: #444650;
        i {
          color: #377cf1;
        }
      }
    }
    // .main-top-fr {
    //   padding-top: 103px;
    //   padding-right: 76px;
    //   margin-left: auto;
    //   font-weight: 500;
    //   font-size: 16px;
    //   color: #9e9e9e;
    //   position: relative;
    //   .banckHome {
    //     position: absolute;
    //     cursor: pointer;
    //     bottom: 8px;
    //     right: 40px;
    //     padding: 4px;
    //     border: 1px solid #9e9e9e;
    //     border-radius: 3px;
    //     // right: 60px;
    //   }
    //   .banckHome:hover {
    //     color: #ffffff;
    //     background-color: #e90d0d;
    //     border: 1px solid #e90d0d;
    //   }
    // }
  }
  .main-bg {
    width: 100%;
    height: 500px;
    background-color: #377cf1;
    // 轮播图
    // .swiper-container {
    //   position: relative;
    //   width: 100%;
    //   height: 100%;
    //   margin: 0 auto;
    //   // margin-bottom: 20px;
    //   // margin-top: 10px;
    //   // overflow: hidden;
    //   .swiper-slide {
    //     img {
    //       width: 100%;
    //       height: 100%;
    //     }
    //   }
    //   /deep/.swiper-pagination-bullet-active {
    //     margin: 0 2px !important;
    //     height: 12px;
    //     width: 12px;
    //     border: 3px solid #fff;
    //     border-radius: 50%;
    //     opacity: 0.8;
    //     // background: #007aff;
    //     background: hsla(0, 0%, 100%, 0.3);
    //   }
    // }
    .main-body {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-top: 55px;
      .main-login {
        // z-index: 99;
        // position: absolute;
        // top: 283px;
        // right: 277px;
        margin-right: 100px;
        width: 290px;
        height: 340px;
        background: #ffffff;
        border-radius: 4px;
        padding: 29px 27px 48px 30px;
        .div-p {
          position: relative;
          display: flex;
          // align-self: flex-end;
          // padding-bottom: 6px;
          border-bottom: 1px solid #e2e2e2;
          .p-1 {
            font-size: 26px;
            font-weight: 500;
            color: #787878;
          }
          .p-2 {
            position: absolute;
            bottom: 5px;
            left: 72px;
            color: #b7b7b7;
            font-size: 12px;
            // line-height: 0;
            // padding-top: 7px;
            // padding-bottom: 17px;
            // letter-spacing: 2px;
          }
        }
        .main-form {
          .ivu-form {
            /deep/.ivu-input-prefix {
              // border-radius: 4px;
              // margin: 4px 4px;
              padding: 6px 7px;
              border: none;
              // background-color: #ffffff;
              // background-color: #e2e2e2;
              .iconfont {
                color: #bbbbbb;
                font-size: 22px;
                // border-radius: 4px;
              }
              /deep/ .i {
                font-size: 22px;
              }
            }
            /deep/.ivu-input {
              border: none;
              border-bottom: 1px solid #e2e2e2;
              border-radius: 0;
            }
            /deep/ .login-no {
              margin-top: 14px;
              margin-bottom: 5px;
              height: 38px;
              span {
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
              }
            }
            /deep/ .ivu-btn:hover {
              border: 0;
            }
          }
          .main-form-username {
            margin: 24px 0 32px 0;
          }
          /deep/ .ivu-form-item-error .ivu-input-group-prepend {
            background-color: #fff;
            border: none;
          }
        }
        /deep/ .ivu-input-group-append {
          border: none;
          background-color: #ffffff;
        }

        .main-spans {
          // margin-top: 50px;
          // display: flex;
          // padding-top: 22px;
          color: #787878;
          // justify-content: space-between;
          text-align: right;
          .i {
            font-size: 12px;
            color: #787878;
          }
          .i:hover {
            color: #377cf1;
            cursor: pointer;
          }
          .i-2 {
            color: #787878;
            font-size: 12px;
            padding: 0 2px;

            // width: 0px;
            // height: 10px;
            // border: 1px solid #000000;
            // opacity: 0.2;
            // margin: 0 11px 0 9px;
          }
        }
        .w122 {
          text-align: left;
          font-size: 12px;
          color: #b7b7b7;
          // padding-top: 6px;
        }
        // display: flex;
        // justify-content: center;
        // > div {
        //   margin-top: 20px;
        //   > div {
        //     display: flex;
        //     align-items: center;
        //     margin-top: 10px;
        //   }
        // }
      }
    }
  }
}
.languageIcon {
  padding-top: 10px;
  padding-left: 30px;
  width: 54px;
  vertical-align: middle;
  // position: absolute;
  // right: -540px;
  // top: -70px;
  // width: 30px;
  // cursor: pointer;
}
/deep/.DropdownDom {
  // position: absolute !important ;
  // will-change: top, left;
  // top: 93px !important;
  // left: 740px !important;
  #tags-p {
    cursor: pointer;
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #000;
  }
  #tags-p:nth-child(1) {
    margin: 20px;
  }
  #tags-p:nth-child(2) {
    margin: 20px 20px 30px;
  }
  #tags-p:hover {
    // color: #0066ff;
  }
  .isDisabled {
    color: #c5c8ce !important;
    cursor: not-allowed !important;
  }
}
/deep/ .ivu-form-item-error .ivu-input-group-prepend {
  background-color: #ffffff;
  border: none !important;
}
</style>
